import { Message } from "element-ui";

const state = {
  shop_goods: localStorage["shop_goods"]
    ? JSON.parse(localStorage["shop_goods"])
    : [],
  all_money: 0, //结算金额
  show_data: null,
  focus: false
};
const getters = {
  carList(state) {
    localStorage.setItem("shop_goods", JSON.stringify(state.shop_goods));
    return state.shop_goods;
  },
  get_focus(state) {
    return state.focus;
  },
  allMoney(state) {
    let all_money = 0;
    state.shop_goods.forEach(item => {
      all_money += Number(item.num) * Number(item.money);
    });
    return (state.all_money = Math.round(Number(all_money) * 100) / 100);
  }
};
const mutations = {
  SET_focus(state, data) {
    state.focus = data;
  },
  ADDGoods(state, data) {
    let datas = {
      //传入的商品属性
      title: data.title,
      pic: data.url == "" ? data.pic : data.url,
      num: 1,
      money: data.money,
      id: data.id,
      stock: data.stock
    };
    let index = state.shop_goods.findIndex(item => {
      //返回元素的索引位置，如果没有符合条件的元素返回 -1
      return item.id == data.id;
    });
    console.log("index", index);
    if (index == -1) {
      //返回-1说明购物车里没有这个商品，则push进去，如果返回下标，则让此商品的数量加1
      state.shop_goods.push(datas);
    } else {
      state.shop_goods[index].num++;
    }
    console.log("vuex", state.shop_goods);
  },
  //修改商品数量
  Input_edit_num(state, val) {
    let index = state.shop_goods.findIndex(item => {
      return item.id == state.show_data.id;
    });
    if (val > state.show_data.stock) {
      Message("请检查库存是否充足!!!");
      state.shop_goods[index].num = state.show_data.stock;
    } else {
      if (val == "") {
        state.shop_goods[index].num = 1;
      } else {
        state.shop_goods[index].num = val;
      }
    }
  },
  //购物车页面数量加减
  JIANNUM(state, productId) {
    let arr = [productId];
    let index = state.shop_goods.findIndex(item => {
      return item.id == productId;
    });
    if (state.shop_goods[index].num <= 1) {
      return (state.shop_goods = state.shop_goods.filter(
        item => !arr.includes(item.id)
      ));
    } else {
      return state.shop_goods[index].num--;
    }
  },
  //清空购物车
  DEL(state) {
    state.shop_goods = [];
    state.show_data = null;
  },
  SET_DATA(state, data) {
    state.show_data = data;
  }
};
const actions = {
  addGoods({ commit }, data) {
    commit("ADDGoods", data);
  },
  setFocus({ commit }, data) {
    commit("SET_focus", data);
  },
  jianNum({ commit }, id) {
    commit("JIANNUM", id);
  },
  setData({ commit }, data) {
    commit("SET_DATA", data);
  },
  Input({ commit }, data) {
    commit("Input_edit_num", data);
  },
  delShop_car({ commit }) {
    commit("DEL");
  }
};
export default {
  state,
  mutations,
  actions,
  getters
};
